/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Box } from "@mui/material";
import { useScroll, useSpring, useInView } from "motion/react";
import { useRef } from "react";
import { OpacityFillingTextLetter, OpacityFillingTextLetterProps } from "./OpacityFillingTextLetter.tsx";

export type OpacityFillingTextProps = {
  text: string;
} & Pick<OpacityFillingTextLetterProps, "fadeOutPercentage" | "disabledOpacity">;

export const OpacityFillingText = ({ text, ...animatedLetterProps }: OpacityFillingTextProps) => {
  const containerRef = useRef<HTMLElement>(null);
  const isInView = useInView(containerRef);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: [
      [0, 0.9],
      [1, 0.5],
    ],
  });

  const progressYSpring = useSpring(scrollYProgress, { bounce: 0 });

  return (
    <Box ref={containerRef}>
      {text.split("").map((letter, idx) => (
        <OpacityFillingTextLetter letter={letter} percentInText={idx / text.length} scrollYProgress={progressYSpring} {...animatedLetterProps} isInView={isInView} />
      ))}
    </Box>
  );
};
